export const SET_ANSWER = 'SET_ANSWER'
export const CLEAR_ANSWER = 'CLEAR_ANSWER'



// WEBPACK FOOTER //
// ./src/containers/Game/containers/Translator/actionTypes.js